import React, { Fragment, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { isEmpty, toastr } from "../../common/cores";
import { SetPerPage } from "../../common/actions/pageAction";
import { perPage, sportPerPage } from "../../utils";
import Popup from "./Popup";

const PrivateRoute = ({
  component: Component,
  auth,
  user, 
  messagePage,
  isPublic,
  isMessagePage,
  messageRouter,
  value,
  gameCheck,
  SetPerPage, 
  path, 
  ...rest
}) => {
  // console.log(isMessagePage);

    useEffect(()=>{
    // console.log('path value: ', path, value);
      if (value === "sport_prematch" || value === "sport_live" || value === "esport_prematch") {
        SetPerPage(sportPerPage);
      }
      else{
        SetPerPage(perPage);
      }
    }, [value])

  if (auth === true) {
    if (messagePage && !isMessagePage) {
      toastr.warning("쪽지를 먼저 확인하셔야 합니다.")
      return (
        <Route {...rest} render={props => <Redirect to={messageRouter} />} />
      );
    }

    if (!isEmpty(value) && user.role < 4) {
      if (gameCheck[value]) {
        toastr.warning("점검중입니다.");
        return <Route {...rest} render={props => <Redirect to="/" />} />;
      }
    }

    return <Route {...rest} render={props => <Fragment> <Popup/> <Component {...props} /> </Fragment>} />;
  } else {

    if (isPublic) {
      return <Route {...rest} render={props => <Fragment> <Popup/> <Component {...props} /> </Fragment>} />;
    }
    // toastr.warning("로그인하시고 이용해주세요.")
    return <Route {...rest} render={props => <Fragment> <Popup/> <Redirect to="/" /> </Fragment>} />;
  }
};

const mapStateToProps = state => ({
  user: state.user.data,
  auth: state.user.isAuthenticated,
  messagePage: state.page.messagePage,
  gameCheck: state.page.gameCheck
});

export default connect(
  mapStateToProps,
  { SetPerPage }
)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/common/PrivateRoute.js